import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { UserService } from '../../dataServices/userService';
import { AzureLoggerService } from '../../services/azureLoggerService';
import { ResetPasswordPageModel } from './reset-password-page.model';
import { MismatchValidator } from '../../validators/mismatch.validator';

@Component({
    selector: 'self-ins-reset-password',
    templateUrl: './reset-password-page.component.html',
    styleUrls: ['./reset-password-page.component.scss']
})
export class ResetPasswordPageComponent {
    public passwordFormGroup = new FormGroup({});
    public newPassword: string = '';
    public confirmPassword: string = '';

    public disableButtons: boolean = false;

    private resetCode: string = '';

    constructor(
        private userService: UserService,
        private progressBar: NgProgress,
        private toastrService: ToastrService,
        private router: Router,
        private azureLoggerService: AzureLoggerService,
        private formBuilder: FormBuilder,
        route: ActivatedRoute
    ) {
        route.queryParams.subscribe(params => {
            this.resetCode = params['code'];
        });

        this.passwordFormGroup = this.formBuilder.group({
            newPassword: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]
        }, {
            validators: [
                MismatchValidator('newPassword', 'confirmPassword')
            ]
        });
    }

    public resetPassword() {
        if (this.newPassword !== this.confirmPassword) {
            return;
        }

        this.progressBar.ref().start();
        this.disableButtons = true;

        const requestModel = {
            resetCode: this.resetCode,
            password: this.newPassword
        } as ResetPasswordPageModel;

        this.userService
            .resetPassword(requestModel)
            .pipe(
                finalize(() => {
                    this.progressBar.ref().complete();
                    this.disableButtons = false;
                })
            )
            .subscribe(
                _ => {
                    this.toastrService.success('Password has been successfully changed.');
                    setTimeout(() => this.router.navigate(['']), 1000);
                },
                _error => {
                    this.azureLoggerService.logException(_error);
                    this.toastrService.error(
                        'Unable to change password, please try again later or contact your system administrator.'
                    );
                }
            );
    }
}